module.exports = __webpack_public_path__ + "img/esg.457bc69.png";